export default __webpack_public_path__ + "static/region-map-top-bg-ba4cfd987fdfeb30f817c6350b764b0d.jpg";